import { render } from "./VoteCardControl.vue?vue&type=template&id=042ce994&scoped=true"
import script from "./VoteCardControl.vue?vue&type=script&lang=js"
export * from "./VoteCardControl.vue?vue&type=script&lang=js"

import "./VoteCardControl.vue?vue&type=style&index=0&id=042ce994&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042ce994"]])

export default __exports__